import { type FunctionComponent } from "react";

import { useSearchContext } from "scmp-app/components/search/contexts";
import { DropdownMenu } from "scmp-app/components/search/search-result-panel/components/dropdown-menu";

import { DateRangeOptions } from "./const";

type Props = {
  className?: string;
};

export const DateRangeMenu: FunctionComponent<Props> = ({ className }) => {
  const { dateRange, setDateRange } = useSearchContext();
  const isChangedOptionColor = dateRange && Object.keys(dateRange).length > 0;

  return (
    <DropdownMenu
      className={className}
      isChangedOptionColor={isChangedOptionColor}
      onOptionSelect={selectedDateRangeOption => {
        setDateRange?.({ ...selectedDateRangeOption.value });
      }}
      options={DateRangeOptions}
      placeholder="Date Range"
      selectedOptionValue={dateRange}
    />
  );
};

DateRangeMenu.displayName = "DateRangeMenu";
